import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useLead } from '../../contexts/LeadContext';
interface ErrorStateProps {
  onRetry: () => void;
}

/** Recoverable submission failure: retry plus a direct WhatsApp route to a Queen. */
export function ErrorState({
  onRetry
}: ErrorStateProps) {
  const {
    t
  } = useLanguage();
  const {
    openPicker
  } = useLead();
  return <div role="alert" className="border border-kred/60 bg-kred/10 p-5" data-id="element-126" data-mp="3oq31b72u3kf6">
      <div className="flex items-start gap-3" data-id="element-127" data-mp="3jrjihfjjeor1">
        <AlertTriangleIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-kred" data-id="element-128" data-mp="3jsujx8pifkez" />
        <p className="text-sm leading-relaxed text-white/85" data-id="element-129" data-mp="2g9zjvadxpss">{t('form.err.submit')}</p>
      </div>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row" data-id="element-130" data-mp="3tqqunzejcdck">
        <button type="button" onClick={onRetry} className="min-h-[48px] flex-1 bg-white px-5 text-sm font-bold uppercase tracking-[0.12em] text-ink" data-id="element-131" data-mp="1dwgo7yt2lv8w">
          {t('form.retry')}
        </button>
        <button type="button" onClick={() => openPicker('form-error')} className="min-h-[48px] flex-1 border border-white/40 px-5 text-sm font-bold uppercase tracking-[0.12em] text-white hover:border-gold hover:text-gold" data-id="element-132" data-mp="3soijcr2d1rkw">
          {t('hero.ctaSecondary')}
        </button>
      </div>
    </div>;
}